var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: ["icon-chevron", _vm.direction],
      attrs: {
        stroke: _vm.stroke,
        xmlns: "http://www.w3.org/2000/svg",
        width: "11.073",
        height: "11.073",
        viewBox: "0 0 11.073 11.073",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M639,45v6.78h6.879",
          transform: "translate(-482.954 424.886) rotate(-45)",
          fill: "none",
          stroke: "#ffde01",
          "stroke-width": "2",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }